import { createRoot } from 'react-dom/client';
import logger from './Logger';

const mountReactRoot = (containerId, element, { optional = false } = {}) => {
    const container = document.getElementById(containerId);
    if (!container) {
        if (!optional) {
            logger.error(`Element with ID ${containerId} was not found in the DOM`);
        }
        return null;
    }
    createRoot(container).render(element);
    return container;
};

export default mountReactRoot;
